import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/why-should-we-hire-you",
  title: "Why Should We Hire You Answer",
  seoTitle: "How to Answer Why Should We Hire You | HiredCoach",
  seoDescription:
    "Answer 'Why should we hire you?' with a focused value pitch, a sample answer, and a direct path into practice and feedback.",
  heroEyebrow: "Value pitch guide",
  heroHeadline: "This answer is not a pep talk. It is your case.",
  heroSubhead:
    "A lot of people answer this with confidence words and zero proof. Not great. The better version is specific, fast, and tied to what the team actually needs.",
  heroPrimaryCta: "Practice this answer",
  heroPanelEyebrow: "What actually works",
  heroPanelTitle: "Make your value obvious",
  heroPanelBullets: [
    "Pick the strengths that matter here",
    "Back them up with real outcomes",
    "Tie those outcomes to this role",
  ],
  heroPanelFooter: "If you stay generic, this answer disappears fast.",
  frameworkTitle: "How to keep this from sounding generic",
  frameworkBullets: [
    "Pick the two or three strengths this team actually cares about.",
    "Tie each one to something you have already done.",
    "Show you understand the problem they are hiring into.",
    "End with what you would help them do sooner or better.",
  ],
  exampleTitle: "What a strong answer sounds like",
  exampleBlocks: [
    "You should hire me because this role needs someone who can translate customer problems into clear product priorities, and that has been a core part of my work.",
    "In my current role I partnered with sales and support to identify recurring friction points, then helped launch workflow improvements that reduced ticket volume and improved activation.",
    "I would bring that same cross-functional approach here so I can help your team move faster on issues that matter to customers.",
  ],
  mistakesTitle: "Where this answer falls apart",
  mistakes: [
    "You repeat the job description and call it an answer.",
    "You talk about wanting the job instead of winning it.",
    "You stack buzzwords with no evidence under them.",
    "You forget to tailor any of it to this company.",
  ],
  ctaEyebrow: "Coach U + practice",
  ctaTitle: "Practice this answer with feedback",
  ctaBullets: [
    "Pick the right strengths",
    "Use proof instead of slogans",
    "Make the fit obvious",
    "Say it until it lands cleanly",
  ],
  ctaInfoCard: {
    title: "Getting started with interviews",
    path: "/public-learn",
    description: "Use Coach U content to tighten your story before you practice this answer.",
  },
  ctaActionTitle: "Practice this answer",
  ctaActionDescription: "Run the question, hear where it gets fuzzy, and sharpen the pitch before the real interview.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "Tell Me About Yourself Interview Answer",
      path: "/tell-me-about-yourself",
      description: "Learn how to answer 'Tell me about yourself' with a clear structure, a sample answer, and a fast path into Coach U practice.",
    },
    {
      title: "Behavioral Interview Questions and Answers",
      path: "/behavioral-interview-questions",
      description: "Review common behavioral interview questions, how to answer them well, and how to practice them with AI feedback.",
    },
    {
      title: "Mock Interview Practice",
      path: "/mock-interview-practice",
      description: "Practice mock interviews with AI feedback, sharpen common interview answers, and turn Coach U frameworks into real interview reps.",
    },
  ],
  faqs: [
    { question: "How long should a why should we hire you answer be?", answer: "Usually under 75 seconds. Long enough to prove your point. Short enough to sound controlled." },
    { question: "Should you mention culture fit?", answer: "Yes, but after the useful part. Skills and results first. Culture fit is not the headline." },
  ],
};

export default function WhyShouldWeHireYouPage() {
  return <SeoLandingTemplate page={page} />;
}
